import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { MobileService } from './api/mobile.service';
import { MultiFactorService } from './api/multiFactor.service';
import { PasswordService } from './api/password.service';
import { UsersService } from './api/users.service';
import { WebService } from './api/web.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [MobileService, MultiFactorService, PasswordService, UsersService, WebService],
})
export class ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
